import axios, { AxiosError } from "axios";
import { Api } from "../axios-config";

interface IAuth {
   accessToken: string;
}
 
export interface IUsuarios {
    usuario: string;
    senha: string;
}

interface ErrorResponse {
  error: {
    default: string;
  };
}

const auth = async (usuario: string, senha: string): Promise<IAuth | Error> => {
  try {
     
    const dados = {
      usuario : usuario,
      senha : senha,
    };

    const { data } = await Api.post('/login', dados);

    if (data) {
      return data;
    }

    return new Error('Erro no login.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

export const AuthService = {
  auth,
};